module.exports = __webpack_public_path__ + "img/demo_plugin.07adbf1a.png";